import ProductBox from '~/themes/oknanebodvere/components/product/ProductBox'
import QuestionMark from '@theme/components/atom/QuestionMark'

export default {
  extends: ProductBox,
  components: { QuestionMark },
  computed: {
    isAvailable() {
      return this.product.availability.isAvailable && this.product.availability.stock > 0
    },
    availableText() {
      const deliveryAttribute = this.activeVariant.attributes.find(attr => attr.delivery_value !== undefined)

      return deliveryAttribute?.delivery_value ?? this.$t('ProductAvailability.order')
    },
    buttonText() {
      return this.isAvailable ? this.$t('ProductBox.button') : this.$t('ProductBox.customButton')
    },
  },
}
